import MainCTA from "../CTA-sections/mainCTA";
import MainForm from "../forms/mainForm";
import FirefoxSection from "./shared-components/firefoxSection";
import FirefoxSectionTitle from "./shared-components/firefoxSectionTitle";
import FirefoxGridView from "./shared-components/firefoxGridView";
import EmailBoxCTA from "./shared-components/emailBoxCTA";
import FirefoxCardView from "./shared-components/firefoxCardView";
import TestimonialView from "../testimonials/testimonialView";
import MassiveText from "./shared-components/massiveText";
import {currentHolidayLong, currentHolidayShort, isHolidayFocus} from "../../models/variableCopywriting";
import {ArrowRightIcon} from "@heroicons/react/16/solid";
import {sendSlackMessageTracked} from "../../models/notifications";
import {WomanWorking} from "../../assets";


export default function GenericPromotionalOfferComponent(props) {

    return (
        <div>
            <main>
                <section className="container container-wide container-single">
                    <section id="" className="ns-bio-hero alignfull">
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content">
                                <h1 className="custom-font"><div className="text-7xl">LEADER FOR THE {currentHolidayShort} OFFER</div></h1>
                                <p className="">
                                    Competitors are systematically capturing major high-ticket customer who searches for what you sell.
                                </p>
                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img decoding="async"
                                     src={WomanWorking}
                                     alt="Vice President Harris excited in front of a large crowd of supporters"/>
                            </figure>
                        </div>
                    </section>
                    {/*TODO: Test with and without the fullwidth */}
                    <div className="alignfull bg-black text-white py-40">

                        <div className="flex items-center justify-center">
                            <div className="" style={{width: '80vw'}}>


                                <div className="bg-gray-900 py-20">
                                    <FirefoxSectionTitle
                                        title="3 Business Moments to Ring the Alarm"
                                        blurb={
                                            <div className="">
                                                <div className="flex justify-center">
                                                    <div className="text-left">
                                                        1. When you first launch. <br/>
                                                        2. When running paid ads. <br/>
                                                        3. After a merger or acquisition. <br/><br/>

                                                        <div>
                                                            But there's a fourth, highly critical moment: <br />* The month before {currentHolidayShort}.&nbsp;&nbsp;
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="px-8">
                                                    <br />
                                                    This {currentHolidayShort} offers the highest-stakes opportunity for sales.
                                                    While your competitors are solely focused on paid traffic, you have a one-month window to secure your organic ranking advantage.
                                                </div>

                                            </div>
                                        }

                                    />

                                    <div className="">
                                    <EmailBoxCTA/>
                                    </div>
                                </div>

                                {/*<div className="my-12">*/}
                                {/*    <MainCTA/>*/}
                                {/*</div>*/}


                                <div className="mt-40">
                                    <FirefoxSectionTitle
                                        title={"Outrank Paid Ads Without Spending a Dime"}
                                        blurb={`Get your foundational SEO in place now, then capture free search traffic for 3 months.`}
                                    />

                                    <FirefoxCardView
                                    />

                                </div>


                                <div className="alignfull">


                                    {/*<div className="alignfull bg-white text-black">*/}
                                    {/*    <MassiveText />*/}
                                    {/*</div>*/}


                                    <FirefoxSection
                                        backgroundColor="black"
                                        textColor="white"

                                        // ctaText="Learn more about SEO"
                                        // ctaShouldShowArrow={true}

                                        imageDirection={"left"}
                                        highlightedText={isHolidayFocus ? `Something New for ${currentHolidayShort}` : ""}
                                        title={<div className="text-4xl">SEO + Ads = Dominating Mindshare</div>}
                                        blurb={<div>
                                            You’re paying for ads to help people learn about your brand. When they
                                            search
                                            for you on Google, you should be easy to find. We help great teams show up
                                            first on Google, reach the right people, and turn that attention into real
                                            growth.
                                        </div>}
                                    />

                                    <div className="py-8 my-12 pb-16" style={{backgroundColor: '#DCD2FF'}}>

                                        <FirefoxSectionTitle
                                            textColor="#333336"
                                            title="Do you qualify? Find out here."
                                            blurb="Organic search is the largest source of website traffic for most industries. This traffic is free, consistent, and targeted."
                                        />
                                        <EmailBoxCTA
                                            textColor="#333336"
                                        />
                                    </div>


                                    {/* Middle of Funnel MOF */}
                                    <div className="mb-32">
                                        <FirefoxSectionTitle
                                            title="Mulitply your marketing"
                                            blurb={<div>
                                                A good SEO strategy is a force multiplier that makes your entire
                                                marketing effort highly efficient, effective, and sustainable.
                                            </div>}

                                        />

                                        <FirefoxGridView

                                        />
                                    </div>

                                    <FirefoxSection
                                        imageDirection={"left"}
                                        title="Force Multiplier"
                                        ctaText={"Explore SEO Retainers"}
                                        ctaLink={"/seo-retainer"}
                                        highlightedText={isHolidayFocus ? `Scaling up for ${currentHolidayShort}` : ""}
                                        blurb={<div>
                                            Google assigns a Quality Score to your PPC keywords based on expected CTR,
                                            ad relevance, and landing page experience. A well-optimized, SEO-friendly
                                            landing page (fast, relevant, easy to navigate) will have a high landing
                                            page experience, which boosts your Quality Score.
                                        </div>}
                                    />

                                    {/* Bottom of funnel */}
                                    <FirefoxSection
                                        title="High Bounce Rate"

                                        highlightedText={"Optimize to Dominate Google Search Results"}
                                        blurb={<div>
                                            A user visits your website and lands on a well-optimized, fast-loading, and
                                            informative site. This is what good SEO delivers and is most likely to convert.
                                            If they land on a slow, poorly structured page, they'll bounce, wasting all
                                            marketing efforts and ruining your website's reputation with Google Search.
                                        </div>}
                                    />

                                    <FirefoxSection
                                        imageDirection={"left"}
                                        title={<div className="text-4xl"> Poor User Experience (UX) </div>}
                                        blurb={<div>
                                            SEO requires a fast-loading website, a mobile-responsive design, intuitive
                                            navigation, and clear, helpful content. Neglecting SEO often means your site
                                            is slow, looks broken on phones, and is difficult for users to navigate.
                                        </div>}
                                    />

                                    <div>

                                        <FirefoxSectionTitle
                                            title={"What's Included?"}
                                            blurb={
                                                <div className="flex justify-center ">

                                                    <ul className="align-top space-y-4 w-1/2">
                                                        <div className="custom-font">
                                                            <li>1. On-page SEO for product and category/collection pages.</li>
                                                            <li>2. Keyword research based on buyer intent.</li>
                                                            <li>3. Optimization of title tags, meta descriptions, headings, and
                                                                image ALT text Internal linking strategy..</li>
                                                            <li>4. Product schema & structured data markup.</li>
                                                            <li>5. URL structure and crawlability analysis.</li>
                                                        </div>
                                                        <div className="custom-font cursor-pointer underline text-blue-300" onClick={() => {
                                                            sendSlackMessageTracked(`Lead has clicked "View All" link - sending to retainer page`)
                                                            window.open("/seo-retainer")
                                                        }}>
                                                            <span className="flex items-center justify-center">
                                                                View All <div className="ml-2"><ArrowRightIcon height={24} width={24} /></div>
                                                            </span>
                                                        </div>
                                                    </ul>
                                                </div>
                                            }
                                        />
                                    </div>

                                    <div className="py-8 my-12 pb-16" style={{backgroundColor: '#DCD2FF'}}>

                                        <FirefoxSectionTitle
                                            textColor="#333336"
                                            title="Do you qualify? Find out here."
                                            blurb="Organic search is the largest source of website traffic for most industries. This traffic is free, consistent, and targeted."
                                        />
                                        <EmailBoxCTA
                                            textColor="#333336"
                                        />
                                    </div>


                                </div>


                                <div className="mb-12">
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>


                                {/* Use this rhetoric at the bottom of pages (make them stop for a one last moment) */}
                                <FirefoxSection
                                    // imageSrc={"https://images.pexels.com/photos/27815871/pexels-photo-27815871.jpeg"}
                                    imageSrc={"https://images.pexels.com/photos/28005544/pexels-photo-28005544.jpeg"}
                                    imageDirection={"left"}
                                    highlightedText={isHolidayFocus ? `Full Recovery Before ${currentHolidayShort}` : ""}

                                    ctaText={"Explore All Services"}
                                    ctaLink="/services/"
                                    title={<div className="text-5xl">Loss of Organic Visibility and Traffic</div>}
                                    blurb={<div>
                                        Neglecting SEO is an active and costly business risk. The "losses" compound over
                                        time and can severely stunt your company's growth and long-term viability.
                                        Without SEO, your website is virtually invisible to people actively searching for
                                        your products, services, or information on Google Search.
                                    </div>}
                                />


                                <p className="text-center">
                                    Right now, millions of high-intent customers are typing "{currentHolidayLong} deals for your
                                    industry"
                                    into Google.
                                    They are browsing and they're ready to buy. But if your website is buried on page
                                    two,
                                    you're invisible to this revenue potential.

                                </p>

                                {/*<div className="">*/}
                                {/*    <TestimonialView />*/}
                                {/*</div>*/}


                                <div className="py-8 my-12 pb-16">

                                    <FirefoxSectionTitle
                                        textColor="#FFF"
                                        title="Qualified? Find out here."
                                        blurb="SEO helps you take control of your search results so your brand shows up everywhere that matters."
                                    />
                                    <EmailBoxCTA
                                        textColor="#FFF"
                                    />
                                </div>


                            </div>
                        </div>

                    </div>


                </section>
            </main>
        </div>
    )
}